export const getEntryUrlMetadata = state => state.entryUrlMetadata;